/**
 * ProfileCard Component
 *
 * Копия Mantine UserCardImage
 * https://ui.mantine.dev/component/user-card-image/
 */

import React, { useRef } from 'react';
import { Card, Avatar, Text, Button, FileButton, ActionIcon, Tooltip } from '@mantine/core';
import { IconUser, IconKey, IconLogout, IconCamera } from '@tabler/icons-react';
import { ROLE_INFO } from '../constants/permissions';

const ProfileCard = ({ user, onLogout, onChangePassword, onUploadAvatar }) => {
  const resetRef = useRef(null);

  const roleInfo = ROLE_INFO[user?.role] || { name: user?.role || 'Пользователь' };

  const fullName = user?.last_name && user?.first_name
    ? `${user.last_name} ${user.first_name}`
    : user?.full_name || user?.email || 'Пользователь';

  const getInitials = () => {
    const first = user?.first_name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || 'U';
    const last = user?.last_name?.[0]?.toUpperCase() || '';
    return first + last;
  };

  const handleFileChange = (file) => {
    if (file && onUploadAvatar) {
      onUploadAvatar(file);
    }
    resetRef.current?.();
  };

  return (
    <Card
      withBorder
      padding={0}
      radius={24}
      style={{
        backgroundColor: 'var(--mantine-color-body)',
        overflow: 'hidden',
        borderRadius: 24,
      }}
    >
      {/* Background Image Section */}
      <div
        style={{
          height: 140,
          backgroundImage: 'url(/images/backgrounds/profile-card-bg.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      {/* Content with padding */}
      <div style={{ padding: '0 24px 24px 24px', position: 'relative' }}>
        {/* Avatar - поверх границы секции */}
        <Avatar
          src={user?.avatar_url}
          size={150}
          radius={150}
          mx="auto"
          mt={-75}
          style={{
            border: '4px solid var(--mantine-color-body)',
          }}
        >
          {!user?.avatar_url && (
            <Text size="xl" fw={600}>
              {getInitials()}
            </Text>
          )}
        </Avatar>

        {/* Кнопка загрузки фото */}
        <FileButton
          resetRef={resetRef}
          onChange={handleFileChange}
          accept="image/png,image/jpeg,image/gif,image/webp"
        >
          {(props) => (
            <Tooltip label="Загрузить фото">
              <ActionIcon
                {...props}
                variant="filled"
                color="gray"
                size="md"
                radius="xl"
                style={{
                  position: 'absolute',
                  top: 50,
                  left: '50%',
                  marginLeft: 50,
                  border: '2px solid var(--mantine-color-body)',
                }}
              >
                <IconCamera size={16} />
              </ActionIcon>
            </Tooltip>
          )}
        </FileButton>

        {/* User Info */}
        <Text ta="center" fz="lg" fw={500} mt="sm">
          {fullName}
        </Text>
        <Text ta="center" fz="sm" c="dimmed">
          {roleInfo.name}
        </Text>
        <Text ta="center" fz="sm" c="dimmed">
          {user?.email}
        </Text>

        {/* Action Buttons */}
        <Button
          fullWidth
          radius="xl"
          mt={32}
          size="md"
          variant="default"
          leftSection={<IconUser size={16} />}
        >
          Профиль
        </Button>
        <Button
          fullWidth
          radius="xl"
          mt="sm"
          size="md"
          variant="default"
          leftSection={<IconKey size={16} />}
          onClick={onChangePassword}
        >
          Сменить пароль
        </Button>
        <Button
          fullWidth
          radius="xl"
          mt="sm"
          size="md"
          variant="default"
          leftSection={<IconLogout size={16} />}
          onClick={onLogout}
          color="red"
        >
          Выход
        </Button>
      </div>
    </Card>
  );
};

export default ProfileCard;
